import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const TableDatabaseNameFragmentGql: DocumentNode = gql`
fragment TableDatabaseNameFragment on Table {
  __typename
  ... on DatabaseTable {
    vizportalId
    database {
      name
      isGrouped
      ... on DatabaseServer {
        hostName
      }
      ... on File {
        filePath
      }
    }
  }
}
`;
